import * as React from 'react';

var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgSheet = function SvgSheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "sheet_svg__icon sheet_svg__icon--sheet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 6.75A.75.75 0 0 1 5.75 6h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 5 6.75ZM5 11.25a.75.75 0 0 1 .75-.75H11a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.629 23.25H2.25a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v11.379a1.5 1.5 0 0 1-.439 1.06l-8.122 8.122a1.5 1.5 0 0 1-1.06.439Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.25 14.5a.75.75 0 0 0-.75.75v7.365a.75.75 0 0 1-1.5 0V15.25A2.25 2.25 0 0 1 15.25 13h7.365a.75.75 0 0 1 0 1.5H15.25Z",
    clipRule: "evenodd"
  })));
};

export { SvgSheet as default };
//# sourceMappingURL=sheet.svg.js.map
